import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn } from '@angular/router';
import { AppStore } from 'src/app/store/app.store';

export const accountRouteGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  if (inject(AppStore).$isLoggedIn()) return true;
  if (route.queryParams['contactId'] && route.queryParams['code']) return true;
  return false;
};
